/** Vocabulário do domínio. Valores em snake_case porque vão direto para o banco. */

export const TIPO_TRANSACAO = {
  ENTRADA: 'entrada',
  SAIDA: 'saida',
} as const;
export type TipoTransacao = (typeof TIPO_TRANSACAO)[keyof typeof TIPO_TRANSACAO];

export const STATUS_TRANSACAO = {
  CONFIRMADA: 'confirmada',
  PENDENTE_REVISAO: 'pendente_revisao',
  DESCARTADA: 'descartada',
} as const;
export type StatusTransacao = (typeof STATUS_TRANSACAO)[keyof typeof STATUS_TRANSACAO];

export const ORIGEM = {
  TEXTO: 'texto',
  AUDIO: 'audio',
  MANUAL: 'manual',
} as const;
export type Origem = (typeof ORIGEM)[keyof typeof ORIGEM];

export const FORMA_PAGAMENTO = {
  PIX: 'pix',
  DINHEIRO: 'dinheiro',
  CREDITO: 'credito',
  DEBITO: 'debito',
  BOLETO: 'boleto',
  TRANSFERENCIA: 'transferencia',
} as const;
export type FormaPagamento = (typeof FORMA_PAGAMENTO)[keyof typeof FORMA_PAGAMENTO];

export const INTENCAO = {
  LANCAMENTO: 'lancamento',
  CONSULTA: 'consulta',
  CORRECAO: 'correcao',
  EXCLUSAO: 'exclusao',
  SAUDACAO: 'saudacao',
  DESCONHECIDO: 'desconhecido',
} as const;
export type Intencao = (typeof INTENCAO)[keyof typeof INTENCAO];

export const PAPEL = {
  ADMIN: 'admin',
  OPERADOR: 'operador',
} as const;
export type Papel = (typeof PAPEL)[keyof typeof PAPEL];

export const STATUS_CONEXAO = {
  DESCONECTADO: 'desconectado',
  AGUARDANDO_QR: 'aguardando_qr',
  CONECTANDO: 'conectando',
  CONECTADO: 'conectado',
  ERRO: 'erro',
} as const;
export type StatusConexao = (typeof STATUS_CONEXAO)[keyof typeof STATUS_CONEXAO];

/**
 * Limiares de confiança da extração (seção 4.4 da especificação).
 *
 * >= AUTO      → grava e confirma no WhatsApp
 * >= REVISAO   → grava como PENDENTE_REVISAO e pergunta
 * <  REVISAO   → não grava, pergunta o que faltou
 *
 * Configuráveis por organização via a tabela `settings`; estes são os padrões.
 */
export const LIMIAR_CONFIANCA = {
  AUTO: 0.85,
  REVISAO: 0.55,
} as const;
